import styled from "styled-components";
import {ErrorText, Text} from "./Shared";
import {solease_cultured, solease_lightblue, solease_red} from "../../constants/Colors";

const Wrapper = styled.div<{ error?: boolean }>`
  width: 100%;
  position: relative;
  margin-bottom: 25px;

  ${Text} {
    margin-bottom: 5px;
  }

  @media (min-width: 900px) {
    max-width: 60%;
  }

  ${ErrorText} {
    opacity: ${props => props.error ? 1 : 0}
  }
  
  label{
    ${Text}{
      margin-right: 90px;
    }
  }

  input {
    border-color: ${props => props.error ? solease_red : 'transparent'}
  }
`

const Input = styled.input`
  width: 100%;
  min-height: 46px;
  background-color: ${solease_cultured};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-size: 14px;
  padding: 0 15px;
  outline: none;
  transition: all .3s;
  border: 1px solid transparent;

  &:focus {
    border-color: ${solease_lightblue};
  }
`

interface StyledInputInterface {
    label: string,
    error?: boolean,
    onChange: (value: string) => void
}

const StyledInput = ({label, error, onChange}: StyledInputInterface) => {

    return (
        <Wrapper error={error}>
            <ErrorText>Dit veld is verplicht</ErrorText>
            <label>
                <Text large>{label}</Text>
                <Input onChange={(e) => onChange(e.target.value)}/>
            </label>
        </Wrapper>
    )
}

export default StyledInput
